import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  formatQueryParams,
  formatRequest,
  JsonApiResponseDto,
  prepareHeaders,
  Request,
  TQueryParams,
} from 'evolve-ui';

export type INumberNotifications = {
  notifications: number;
  tasks: number;
};

const parseNotificationsCounts = (
  response: JsonApiResponseDto<INumberNotifications>
) => response?.data?.attributes?.data as INumberNotifications;

export const notificationsApi = createApi({
  reducerPath: 'notifications',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.GATSBY_NOTIFICATIONS_API_URL}`,
    mode: 'cors',
    prepareHeaders,
  }),
  tagTypes: ['Notifications', 'AnadoluNotifications'],
  endpoints: (builder) => ({
    getNumberNotifications: builder.query<INumberNotifications, TQueryParams>({
      providesTags: ['Notifications'],
      query: formatQueryParams,
      transformResponse: parseNotificationsCounts,
    }),
    getAnadoluNumberNotifications: builder.query<
      INumberNotifications,
      TQueryParams
    >({
      providesTags: ['AnadoluNotifications'],
      query: (params) => formatQueryParams(params, 'anadolu'),
      transformResponse: parseNotificationsCounts,
    }),
    markAllNotificationAsRead: builder.mutation({
      invalidatesTags: ['Notifications'],
      query: () =>
        formatRequest({ type: 'notification' }, Request.POST, `markAsRead`),
    }),
    markAllAnadoluNotificationAsRead: builder.mutation({
      invalidatesTags: ['AnadoluNotifications'],
      query: () =>
        formatRequest(
          { type: 'anadolu-notification' },
          Request.POST,
          `anadolu/markAsRead`
        ),
    }),
  }),
});

export const {
  useGetNumberNotificationsQuery,
  useGetAnadoluNumberNotificationsQuery,
  useMarkAllNotificationAsReadMutation,
  useMarkAllAnadoluNotificationAsReadMutation,
} = notificationsApi;
